import { makeApiCall } from "../apirequest";

export default ({
  state: {
    dashboard: {},
  },
  getters: {
    getDashboard: (state) => state.dashboard,
  },
  mutations: {
    SET_DASHBOARD(state, dashboard) {
      state.dashboard = dashboard;
    },
  },
  actions: {
    async getDashboard({ commit }, { startDate, endDate }) {
      // Construct the URL based on whether dates are provided
      let url = 'Admin/GetDashboardStats';
      if (startDate !== null && endDate !== null) {
        url += `?startDate=${startDate}&endDate=${endDate}`;
      }

      try {
        const response = await makeApiCall(url);
        if (response && response.data) {
          commit('SET_DASHBOARD', response.data);
        } else {
          console.error("Response data is undefined or not in expected format.");
        }
        return response;
      } catch (error) {
        console.error("Error in getDashboard action:", error);
        throw error; // Rethrow the error to handle it in the component
      }
    },
  },
  modules: {
  }
})
